import { getContrast } from "polished";
import { ImgixAspectRatio } from "../index";
import { useEffect, useLayoutEffect, useState } from "react";
export const randomLetter = () => String.fromCharCode(65 + Math.floor(Math.random() * 26));
export const randomId = () => `${randomLetter()}-${randomLetter()}-${Date.now()}`;
export function colorTest(hex1, hex2) {
    if (hex1.length > 4 && hex2.length > 4) {
        const ratio = getContrast(hex1, hex2);
        return ratio; // does it meet aa large text (as we are doing this for borders we want it to fail easily)
    }
    else {
        return 1;
    }
}
export const getWindowDimensions = () => {
    if (typeof window === "undefined") {
        return { windowWidth: 0, windowHeight: 0 };
    }
    return {
        windowWidth: window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth,
        windowHeight: window.innerHeight ||
            document.documentElement.clientHeight ||
            document.body.clientHeight
    };
};
export const ratioToCalc = (r) => {
    switch (r) {
        case "16:9":
            return 9 / 16;
        case "1:1":
            return 1;
        case "3:4":
            return 4 / 3;
        case "4:3":
            return 3 / 4;
        case "21:9":
            return 9 / 21;
        case "none":
            return 1;
        default:
            return 9 / 16;
    }
};
export const ImgIXRatio = (r) => {
    switch (r) {
        case "16:9":
            return ImgixAspectRatio.ar16x9;
        case "1:1":
            return ImgixAspectRatio.ar1x1;
        case "3:4":
            return ImgixAspectRatio.ar3x4;
        case "4:3":
            return ImgixAspectRatio.ar4x3;
        case "21:9":
            return ImgixAspectRatio.ar21x9;
        case "none":
            return ImgixAspectRatio.ar_none;
        default:
            return ImgixAspectRatio.ar16x9;
    }
};
// used for the google map slice
export function xmlToJson(xml) {
    // Create the return object
    let obj = {};
    if (xml.nodeType === 1) {
        // element
        // do attributes
        if (xml.attributes.length > 0) {
            obj["@attributes"] = {};
            for (let j = 0; j < xml.attributes.length; j++) {
                const attribute = xml.attributes.item(j);
                obj["@attributes"][attribute.nodeName] = attribute.nodeValue;
            }
        }
    }
    else if (xml.nodeType === 3) {
        // text
        obj = xml.nodeValue;
    }
    // do children
    if (xml.hasChildNodes()) {
        for (let i = 0; i < xml.childNodes.length; i++) {
            const item = xml.childNodes.item(i);
            const nodeName = item.nodeName;
            if (typeof obj[nodeName] === "undefined") {
                obj[nodeName] = xmlToJson(item);
            }
            else {
                if (typeof obj[nodeName].push === "undefined") {
                    const old = obj[nodeName];
                    obj[nodeName] = [];
                    obj[nodeName].push(old);
                }
                obj[nodeName].push(xmlToJson(item));
            }
        }
    }
    return obj;
}
export const isTouchDevice = () => isBrowser() && ("ontouchstart" in window || navigator.maxTouchPoints > 0);
export const isBrowser = () => typeof window !== "undefined";
export function ifBrowser(fn) {
    if (isBrowser()) {
        return fn();
    }
    else {
        return undefined;
    }
}
const useIsomorphicLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;
// Ensure the name used in components is useLayoutEffect
export default { useLayoutEffect: useIsomorphicLayoutEffect };
export function useLockBodyScroll(dependency) {
    const [overflow, storeOverflow] = useState(undefined);
    return useIsomorphicLayoutEffect(() => {
        ifBrowser(() => {
            if (dependency) {
                storeOverflow(window.getComputedStyle(document.body).overflow);
                document.body.style.overflow = "hidden";
            }
            else if (!dependency && !!overflow) {
                document.body.style.overflow = overflow;
                storeOverflow(undefined);
            }
        });
    }, [dependency]);
}
//# sourceMappingURL=index.js.map